<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  aria-labelledby="register-parking-form-title" role="dialog" aria-modal="true">
  <div
    class="relative w-full max-w-6xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[92vh] animate-fade-in-up">

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 id="register-parking-form-title"
          class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">{{ isEditMode ? 'edit_note' : 'app_registration' }}</span>
          {{ formTitle }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          {{ formSubtitle }}
        </p>
      </div>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar">
      <div class="text-slate-600 dark:text-slate-300" (click)="closeDropdowns()">
        <div class="overflow-hidden">

          <!-- Section 1: Top Selection -->
          <div
            class="p-4 md:px-6 md:pt-5 md:pb-4 bg-white dark:bg-slate-900/40 relative border-b border-slate-100 dark:border-slate-800 z-50">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 w-full">
              <div class="relative w-full z-20">
                <ng-container *ngTemplateOutlet="selectField; context: { 
                  label: 'สถานที่ (Location)', 
                  key: 'locations', 
                  options: locationOptions, 
                  selected: selectedLocationId, 
                  icon: 'place', 
                  placeholder: '-- เลือกสถานที่ --',
                  disabled: selectedItems.length > 0 || locationLocked
                }"></ng-container>
              </div>

              <div class="relative w-full z-10">
                <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                  ลูกค้า (Customer) <span class="text-rose-500">*</span>
                </label>
                <div class="relative group" (click)="$event.stopPropagation();">
                  <div class="relative flex items-center bg-white dark:bg-slate-800 border-2 rounded-xl transition-all duration-200 focus-within:ring-4 focus-within:ring-amber-500/10 shadow-[0_2px_10px_-3px_rgba(0,0,0,0.05)] min-h-[40px]"
                    [ngClass]="{
                      'border-slate-200 dark:border-slate-700 focus-within:border-amber-400 dark:focus-within:border-amber-500': !selectedItems.length && !isCustomerFieldLocked,
                      'bg-slate-50 border-slate-100 dark:border-slate-700/50 opacity-70 cursor-not-allowed': selectedItems.length > 0 || isCustomerFieldLocked
                    }">
                    <div class="w-6 h-6 rounded-md flex items-center justify-center transition-colors shadow-sm flex-shrink-0 ml-3"
                      [ngClass]="selectedCustomerId ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                      <span class="material-icons text-[14px]">people</span>
                    </div>
                    <input type="text" [(ngModel)]="customerSearchText" (focus)="openCustomerDropdown()"
                      (input)="onCustomerSearchInput()" (blur)="closeCustomerDropdown()"
                      [disabled]="selectedItems.length > 0 || isCustomerFieldLocked" placeholder="-- เลือกลูกค้า --"
                      class="w-full pl-2 pr-9 py-2 bg-transparent border-none text-[13px] font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400 disabled:cursor-not-allowed">
                    <button *ngIf="selectedCustomerId && selectedItems.length === 0 && !isCustomerFieldLocked" type="button"
                      (mousedown)="$event.preventDefault(); clearCustomerSelection()"
                      class="absolute right-2 text-slate-400 hover:text-rose-500">
                      <span class="material-icons text-lg">close</span>
                    </button>
                  </div>

                  <button *ngIf="isCustomerDropdownOpen" type="button" class="fixed inset-0 z-[90] cursor-default"
                    (click)="closeCustomerDropdown()"></button>
                  <div *ngIf="isCustomerDropdownOpen"
                    class="absolute z-[100] top-full mt-1.5 left-0 right-0 max-h-56 overflow-y-auto bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] py-1.5 custom-scrollbar animate-fade-in-up">
                    <button *ngFor="let option of customerFilterOptions" type="button"
                      (mousedown)="$event.preventDefault(); selectCustomerOption(option.value)"
                      class="w-full text-left px-3 py-2.5 text-[12px] transition-colors flex items-center justify-between group"
                      [ngClass]="{
                        'bg-amber-50/80 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold': selectedCustomerId === option.value,
                        'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-800 dark:hover:text-slate-100 font-medium': selectedCustomerId !== option.value
                      }">
                      <span class="min-w-0 pr-2 flex flex-col">
                        <span class="truncate block overflow-hidden text-ellipsis">{{ option.label }}</span>
                        <span class="truncate text-[11px] font-medium"
                          [ngClass]="option.clientName ? 'text-slate-400 dark:text-slate-500' : 'text-rose-400'">
                          {{ option.clientName || 'ยังไม่ผูกบริษัทผู้เช่า' }}
                        </span>
                      </span>
                      <span *ngIf="selectedCustomerId === option.value"
                        class="material-icons text-[16px] text-amber-500 animate-scale-up flex-shrink-0">check_circle</span>
                    </button>
                    <div *ngIf="customerFilterOptions.length === 0"
                      class="px-3 py-2 text-[12px] text-slate-400 italic">ไม่พบลูกค้าของลานนี้</div>
                    <div *ngIf="!customerSearchText.trim() && customers.length > 20"
                      class="px-3 py-2 text-xs text-slate-400 border-t border-slate-100 dark:border-slate-700">
                      แสดง 20 รายการแรก — พิมพ์เพื่อค้นหาเพิ่ม
                    </div>
                  </div>
                </div>
              </div>

              <div class="relative w-full z-10">
                <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                  บริษัทผู้เช่า <span class="text-rose-500">*</span>
                  <span class="normal-case tracking-normal font-medium text-slate-400 dark:text-slate-500">(อิงจากข้อมูลลูกค้า)</span>
                </label>
                <div class="relative flex items-center border-2 rounded-xl min-h-[40px] bg-slate-50 dark:bg-slate-800/60 cursor-not-allowed"
                  [ngClass]="isSelectedCustomerUnlinked
                    ? 'border-rose-200 dark:border-rose-800/60'
                    : 'border-slate-100 dark:border-slate-700/50'">
                  <div class="w-6 h-6 rounded-md flex items-center justify-center shadow-sm flex-shrink-0 ml-3"
                    [ngClass]="selectedClientId ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                    <span class="material-icons text-[14px]">store</span>
                  </div>
                  <span class="pl-2 pr-3 py-2 text-[13px] font-medium truncate"
                    [ngClass]="selectedClientId ? 'text-slate-700 dark:text-slate-200' : 'text-slate-400'">
                    {{ selectedClientName || (selectedCustomerId ? '-' : 'เลือกลูกค้าก่อน') }}
                  </span>
                  <span class="material-icons text-[16px] text-slate-300 dark:text-slate-600 ml-auto mr-3">lock</span>
                </div>
                <p *ngIf="isSelectedCustomerUnlinked" class="mt-1.5 text-[11px] font-medium text-rose-500 flex items-center gap-1">
                  <span class="material-icons text-[14px]">warning</span>
                  ลูกค้ารายนี้ยังไม่ได้ผูกบริษัทผู้เช่า — กำหนดที่หน้าจัดการลูกค้าก่อน
                </p>
              </div>
            </div>
          </div>

          <div class="p-4 md:px-6 md:py-5 border-b border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900/20 relative z-40">
            <div class="col-span-1 md:col-span-2">
              <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2.5">
                ประเภทรถ <span class="text-rose-500">*</span>
              </label>

              <div class="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
                <button *ngFor="let c of carTypes" (click)="selectCarType(c.id)"
                  [disabled]="selectedItems.length > 0"
                  class="relative flex flex-row items-center justify-start px-4 py-3 border-2 rounded-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer group h-16"
                  [ngClass]="{
                    'border-amber-400 dark:border-amber-500 bg-amber-50 dark:bg-amber-900/20 shadow-sm transform scale-[1.02]': selectedVehicleTypeId === c.id,
                    'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-500/50 hover:bg-amber-50/50 dark:hover:bg-slate-800/80': selectedVehicleTypeId !== c.id
                  }">
                  <div *ngIf="selectedVehicleTypeId === c.id"
                    class="absolute top-1/2 -translate-y-1/2 right-3 text-amber-500 animate-scale-up">
                    <span class="material-icons text-base">check_circle</span>
                  </div>

                  <div class="mr-3 transition-transform duration-300"
                    [class.scale-110]="selectedVehicleTypeId === c.id">
                    <span class="material-icons-outlined text-2xl transition-colors duration-300"
                      [ngClass]="selectedVehicleTypeId === c.id ? 'text-amber-500' : 'text-slate-400 group-hover:text-amber-400'">
                      {{ c.icon }}
                    </span>
                  </div>

                  <span class="text-[13px] font-bold transition-colors duration-300 pr-5 truncate"
                    [ngClass]="selectedVehicleTypeId === c.id ? 'text-amber-700 dark:text-amber-400' : 'text-slate-500 group-hover:text-slate-700 dark:group-hover:text-slate-300'">
                    {{ c.typeName }}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Section 2: Details & Settings -->
          <div class="p-4 md:px-6 md:py-5 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 bg-slate-50/50 dark:bg-slate-900/30 relative z-30">
            <!-- Left Column: Settings (Mode, Payment) -->
            <div class="space-y-5 md:space-y-6 flex flex-col justify-start">
              <div>
                <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2.5">รูปแบบการสมัคร</label>
                <div class="grid grid-cols-2 gap-3 md:gap-4">
                  <label class="relative flex items-center p-2.5 border-2 rounded-xl cursor-pointer transition-all duration-300 w-full group overflow-hidden"
                    [ngClass]="mode === 'new' 
                      ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-md shadow-amber-200/20' 
                      : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-500/50 hover:shadow-sm'">
                    
                    <!-- Background glow for active state -->
                    <div *ngIf="mode === 'new'"
                      class="absolute -right-4 -bottom-4 w-12 h-12 bg-amber-400/30 rounded-full blur-xl animate-pulse">
                    </div>

                    <div class="flex items-center gap-2.5 relative z-10 w-full">
                      <input type="radio" value="new" [(ngModel)]="mode" (ngModelChange)="onModeChange($event)" [disabled]="selectedItems.length > 0 || isModeLocked"
                        class="sr-only">

                      <div class="w-5 h-5 rounded-full border-2 bg-white dark:bg-slate-800 flex items-center justify-center transition-all duration-300 flex-shrink-0 relative shadow-inner"
                        [ngClass]="mode === 'new' 
                          ? 'border-amber-500 ring-4 ring-amber-500/20' 
                          : 'border-slate-300 dark:border-slate-600 group-hover:border-amber-400'">
                        <div class="w-2.5 h-2.5 rounded-full bg-amber-500 transition-transform duration-300 shadow-[0_0_8px_rgba(245,158,11,0.6)]"
                          [ngClass]="mode === 'new' ? 'scale-100' : 'scale-0'"></div>
                      </div>

                      <div class="flex items-center gap-2">
                        <span class="text-[13px] font-bold leading-tight"
                          [ngClass]="mode === 'new' ? 'text-amber-800 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300'">
                          สมัครใหม่
                        </span>
                      </div>
                    </div>
                  </label>

                  <label class="relative flex items-center p-2.5 border-2 rounded-xl cursor-pointer transition-all duration-300 w-full group overflow-hidden"
                    [ngClass]="mode === 'renew' 
                      ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-md shadow-amber-200/20' 
                      : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-500/50 hover:shadow-sm'">

                    <!-- Background glow for active state -->
                    <div *ngIf="mode === 'renew'"
                      class="absolute -right-4 -bottom-4 w-12 h-12 bg-amber-400/30 rounded-full blur-xl animate-pulse">
                    </div>

                    <div class="flex items-center gap-2.5 relative z-10 w-full">
                      <input type="radio" value="renew" [(ngModel)]="mode" (ngModelChange)="onModeChange($event)"
                        [disabled]="selectedItems.length > 0 || isModeLocked" class="sr-only">

                      <div class="w-5 h-5 rounded-full border-2 bg-white dark:bg-slate-800 flex items-center justify-center transition-all duration-300 flex-shrink-0 relative shadow-inner"
                        [ngClass]="mode === 'renew' 
                          ? 'border-amber-500 ring-4 ring-amber-500/20' 
                          : 'border-slate-300 dark:border-slate-600 group-hover:border-amber-400'">
                        <div class="w-2.5 h-2.5 rounded-full bg-amber-500 transition-transform duration-300 shadow-[0_0_8px_rgba(245,158,11,0.6)]"
                          [ngClass]="mode === 'renew' ? 'scale-100' : 'scale-0'"></div>
                      </div>

                      <div class="flex items-center gap-2">
                        <span class="text-[13px] font-bold leading-tight"
                          [ngClass]="mode === 'renew' ? 'text-amber-800 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300'">
                          ต่ออายุ
                        </span>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <!-- Financial Category -->
              <div class="space-y-4 md:space-y-5 bg-white dark:bg-slate-800 rounded-2xl p-4 md:p-5 border border-slate-100 dark:border-slate-700/60 shadow-sm relative overflow-visible z-30 h-max flex-1">
                <h3 class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 flex items-center gap-2">
                  <span class="material-icons text-sm">payments</span>
                  ข้อมูลการชำระเงิน (Financial)
                </h3>

                <!-- Invoice ID -->
                <div class="relative z-30">
                  <ng-container *ngTemplateOutlet="selectField; context: { 
                    label: 'Invoice', 
                    key: 'invoices', 
                    options: invoiceOptions, 
                    selected: selectedInvoiceId, 
                    icon: 'receipt_long', 
                    placeholder: 'เลือก Invoice',
                    disabled: selectedItems.length > 0
                  }"></ng-container>
                </div>

                <!-- Payment Type & Bank -->
                <div class="grid grid-cols-1 gap-5">
                  <div class="relative z-20">
                    <ng-container *ngTemplateOutlet="selectField; context: { 
                      label: 'ประเภทชำระเงิน', 
                      key: 'paymentTypes', 
                      options: paymentTypeOptions, 
                      selected: selectedPaymentTypeId, 
                      icon: 'account_balance_wallet', 
                      placeholder: '-- เลือก --',
                      disabled: selectedItems.length > 0
                    }"></ng-container>
                  </div>

                  <div *ngIf="selectedPaymentTypeId?.toString() === '3'" class="animate-fade-in-up relative z-10">
                    <ng-container *ngTemplateOutlet="selectField; context: { 
                      label: 'ธนาคารที่โอนเข้า', 
                      key: 'banks', 
                      options: bankOptions, 
                      selected: selectedBankId, 
                      icon: 'account_balance', 
                      placeholder: '-- เลือกธนาคาร --',
                      disabled: selectedItems.length > 0
                    }"></ng-container>
                  </div>
                </div>

                <hr class="border-slate-100 dark:border-slate-700/60">

                <!-- Delayed Payment -->
                <div class="pt-2">
                  <label class="flex items-center gap-2 cursor-pointer group w-max">
                    <div class="relative flex items-center justify-center">
                      <input type="checkbox" [(ngModel)]="delayed" [disabled]="selectedItems.length > 0"
                        class="sr-only">
                      <div class="w-[18px] h-[18px] border-2 rounded-md flex items-center justify-center transition-all duration-300"
                        [ngClass]="delayed 
                          ? 'bg-amber-500 border-amber-500 shadow-sm shadow-amber-500/25' 
                          : (selectedItems.length > 0 
                            ? 'bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 opacity-50' 
                            : 'bg-white dark:bg-slate-800 border-slate-300 dark:border-slate-600 hover:border-amber-400 dark:hover:border-amber-500')">
                        <svg class="w-3 h-3 text-white transition-transform duration-300" fill="none"
                          viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"
                          [ngClass]="delayed ? 'scale-100' : 'scale-0'">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <span class="text-[13px] font-bold text-slate-700 dark:text-slate-200 select-none group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors leading-tight">แจ้งโอนเงินล่าช้า</span>
                      <span class="text-[11px] text-slate-400 font-medium">(Delayed Payment)</span>
                    </div>
                  </label>
                </div>

                <!-- Due Date (Conditional) -->
                <div *ngIf="delayed"
                  class="animate-fade-in-up space-y-4 pl-8 border-l-2 border-slate-100 dark:border-slate-700 ml-2.5">
                  <div>
                    <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">วันที่โอนเงิน (Due Date)</label>
                    <div class="relative">
                      <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">calendar_month</span>
                      <input type="date" [(ngModel)]="dueDate" [max]="today"
                        [disabled]="selectedItems.length > 0"
                        class="w-full pl-9 pr-3 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-slate-700 dark:text-slate-200 text-sm font-medium transition-all disabled:opacity-70 disabled:bg-slate-50 disabled:cursor-not-allowed [color-scheme:light] dark:[color-scheme:dark]">
                    </div>
                  </div>

                  <div *ngIf="checkDueDateDelay()" class="animate-fade-in">
                    <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">เลขที่ใบเสร็จ (Receipt No.) <span class="text-rose-500">*</span></label>
                    <div class="relative">
                      <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">receipt</span>
                      <input type="text" [(ngModel)]="receiptNo" placeholder="ระบุเลขที่ใบเสร็จ"
                        class="w-full pl-9 pr-3 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-slate-700 dark:text-slate-200 text-sm font-medium transition-all placeholder:text-slate-400">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Column: Tax Invoice -->
            <div class="h-max">
              <div class="rounded-2xl p-4 md:p-5 transition-all duration-500 relative overflow-visible h-full flex flex-col group/tax-card"
                [ngClass]="{
                  'bg-gradient-to-br from-amber-50 to-orange-50/50 dark:from-amber-900/20 dark:to-orange-900/10 border-2 border-amber-400/50 dark:border-amber-700/50 shadow-md shadow-amber-500/5 ring-4 ring-amber-500/5': taxInvoiceNeeded,
                  'bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700/60 shadow-sm hover:border-amber-200 dark:hover:border-slate-600': !taxInvoiceNeeded
                }">

                <div class="flex justify-between items-start mb-4">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 shadow-sm"
                      [ngClass]="taxInvoiceNeeded ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 rotate-12' : 'bg-slate-100 dark:bg-slate-700/50 text-slate-400'">
                      <span class="material-icons text-[24px]">description</span>
                    </div>
                    <div class="flex flex-col">
                      <h3 class="text-sm font-bold leading-tight"
                        [ngClass]="taxInvoiceNeeded ? 'text-amber-800 dark:text-amber-400' : 'text-slate-700 dark:text-slate-200'">
                        ใบกำกับภาษีเต็มรูป
                      </h3>
                      <p class="text-[11px] text-slate-400 mt-0.5">(Tax Invoice Detailed)</p>
                    </div>
                  </div>

                  <!-- Modern Toggle Switch -->
                  <div (click)="selectedCustomerId !== null && taxInvoiceNeeded = !taxInvoiceNeeded"
                    class="relative w-11 h-6 rounded-full cursor-pointer transition-all duration-300 ring-4 ring-transparent hover:ring-slate-100 dark:hover:ring-slate-800"
                    [ngClass]="{
                      'bg-amber-500 shadow-inner shadow-amber-600/20': taxInvoiceNeeded,
                      'bg-slate-200 dark:bg-slate-700': !taxInvoiceNeeded,
                      'opacity-50 cursor-not-allowed': selectedCustomerId === null
                    }">
                    <div class="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md transition-all duration-300 flex items-center justify-center"
                      [ngClass]="{'translate-x-5': taxInvoiceNeeded}">
                      <span class="material-icons text-[9px] text-amber-500 font-bold scale-0 transition-transform leading-none"
                        [ngClass]="{'scale-70 pt-0.5': taxInvoiceNeeded}"
                        style="display: flex; align-items: center; justify-content: center;">
                        check
                      </span>
                    </div>
                  </div>
                </div>

                <div *ngIf="taxInvoiceNeeded" class="animate-fade-in-up space-y-4">
                  <div class="relative z-50">
                    <ng-container *ngTemplateOutlet="selectField; context: { 
                      label: 'ที่อยู่ออกใบกำกับภาษี', 
                      key: 'taxs', 
                      options: taxOptions, 
                      selected: selectedTaxAddressId, 
                      icon: 'home_work', 
                      placeholder: '-- เลือกที่อยู่ --',
                      disabled: false
                    }"></ng-container>
                  </div>

                  <div class="flex justify-end mt-2 relative z-0">
                    <button (click)="openFulltaxModal()"
                      class="text-xs font-bold text-amber-600 dark:text-amber-400 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border border-amber-200 dark:border-amber-900/50 px-2.5 py-1.5 rounded-lg hover:bg-amber-100 dark:hover:bg-amber-900/50 hover:shadow-sm transition-all flex items-center gap-1.5 cursor-pointer">
                      <span class="material-icons text-[14px]">add</span>
                      เพิ่มที่อยู่ใหม่
                    </button>
                  </div>
                </div>

                <div *ngIf="!taxInvoiceNeeded"
                  class="text-sm text-slate-400 dark:text-slate-500 font-medium italic text-center py-5 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-dashed border-slate-200 dark:border-slate-700 mt-auto">
                  ไม่ต้องออกใบกำกับภาษี
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3: Notes & Items Table -->
          <div class="px-4 md:px-6 py-5 bg-white dark:bg-slate-900/20 border-t border-slate-100 dark:border-slate-800 pb-6">
            <!-- Notes -->
            <div class="mb-6 w-full">
              <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">หมายเหตุเพิ่มเติม</label>
              <textarea [(ngModel)]="description" rows="2" placeholder="ระบุหมายเหตุเพิ่มเติม (ถ้ามี)"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-900 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-slate-700 dark:text-slate-200 text-sm font-medium transition-all resize-y min-h-[60px] hover:border-amber-300 dark:hover:border-amber-500/50"></textarea>
            </div>

            <div class="flex justify-between items-center mb-4">
              <div class="flex items-center gap-3">
                <div class="w-9 h-9 rounded-xl bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                  <span class="material-icons text-[20px]">directions_car</span>
                </div>
                <div>
                  <h3 class="text-base font-bold text-slate-800 dark:text-slate-100 leading-tight">รายการสมัคร (Items)</h3>
                  <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">ระบุข้อมูลรถที่ต้องการสมัคร / ต่ออายุ</p>
                </div>
              </div>
              <button (click)="openAddModal()"
                class="bg-amber-400 hover:bg-amber-500 text-white px-3 py-2 rounded-xl text-sm font-bold shadow-[0_4px_10px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_15px_rgb(251,191,36,0.5)] transition-all flex items-center gap-1.5 cursor-pointer transform hover:-translate-y-0.5 active:translate-y-0 relative overflow-hidden group">
                <div class="absolute inset-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-shimmer skew-x-12"></div>
                <span class="material-icons text-[18px]">add_circle</span>
                <span class="hidden md:inline">เพิ่มรายการจอดรถ</span>
                <span class="md:hidden">เพิ่ม</span>
              </button>
            </div>

            <!-- Table Container -->
            <div class="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden w-full relative">
              <div class="overflow-x-auto custom-scrollbar">
                <table class="w-full min-w-[900px] border-collapse text-sm">
                  <thead class="bg-slate-50 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700" style="position: sticky; top: 0; z-index: 10;">
                    <tr>
                      <th class="py-4 px-5 text-center text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide w-16">#</th>
                      <th class="py-4 px-5 text-left text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide">Package</th>
                      <th class="py-4 px-5 text-left text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide">ทะเบียนรถ</th>
                      <th class="py-4 px-5 text-left text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide">วันเริ่มใช้งาน</th>
                      <th class="py-4 px-5 text-right text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide w-32">ราคาบัตร</th>
                      <th class="py-4 px-5 text-right text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide w-32">VAT</th>
                      <th class="py-4 px-5 text-right text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide w-36">ราคารวม</th>
                      <th class="py-4 px-5 text-center text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide w-24">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100 dark:divide-slate-700/50">
                    <!-- Empty State -->
                    <tr *ngIf="selectedItems.length === 0">
                      <td colspan="8" class="py-16 px-4 text-center">
                        <div class="flex flex-col items-center justify-center opacity-70">
                          <div class="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4 border border-slate-200 dark:border-slate-700">
                            <span class="material-icons text-3xl text-slate-400">directions_car</span>
                          </div>
                          <p class="text-slate-500 dark:text-slate-400 font-medium">ยังไม่มีรายการ</p>
                          <p class="text-xs text-slate-400 mt-1">คลิกปุ่ม "เพิ่มรายการ" เพื่อเพิ่มข้อมูล</p>
                        </div>
                      </td>
                    </tr>

                    <tr *ngFor="let item of selectedItems; let i = index"
                      class="hover:bg-amber-50/50 dark:hover:bg-slate-700/30 transition-colors group border-b border-slate-100 dark:border-slate-700/50 last:border-0">
                      <td class="py-2 px-4 font-bold text-slate-400 text-center text-[13px]">{{ i + 1 }}</td>
                      <td class="py-2 px-4">
                        <div class="flex items-center gap-2">
                          <div class="w-8 h-8 rounded-lg bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 flex items-center justify-center flex-shrink-0">
                            <span class="material-icons text-[18px]">badge</span>
                          </div>
                          <span class="text-[13px] font-bold text-slate-700 dark:text-slate-200">{{ item.feeName }}</span>
                        </div>
                      </td>
                      <td class="py-2 px-4">
                        <div class="flex flex-wrap gap-1.5">
                          <span *ngFor="let vehicle of item.memberVehiclesPayloads"
                            class="px-2 py-0.5 bg-slate-100 dark:bg-slate-700 rounded border border-slate-200 dark:border-slate-600 font-mono font-bold text-[11px] text-slate-700 dark:text-slate-200 shadow-sm">
                            {{ vehicle.license }}
                          </span>
                          <span *ngIf="!item.memberVehiclesPayloads || item.memberVehiclesPayloads.length === 0"
                            class="text-slate-400 text-xs italic">- ไม่มีข้อมูลรถ -</span>
                        </div>
                      </td>
                      <td class="py-2 px-4 font-medium text-slate-600 dark:text-slate-300 text-[13px]">{{ item.memberStartDate | date:'dd/MM/yyyy' }}</td>
                      <td class="py-2 px-4 font-medium text-slate-600 dark:text-slate-300 text-right text-[13px]">{{ unitAmounts(item).subTotal | number:'1.2-2' }}</td>
                      <td class="py-2 px-4 font-medium text-slate-600 dark:text-slate-300 text-right text-[13px]">{{ unitAmounts(item).vatAmount | number:'1.2-2' }}</td>
                      <td class="py-2 px-4 text-right">
                        <div class="flex items-center justify-end gap-1.5">
                          <span class="text-blue-600 dark:text-blue-400 font-bold text-[13px]">{{ lineAmounts(item).total | number:'1.2-2' }}</span>
                          <span class="text-[10px] text-slate-500 bg-slate-100 dark:bg-slate-700 px-1 py-0.5 rounded font-mono">x{{item.memberVehiclesPayloads.length}}</span>
                        </div>
                      </td>
                      <td class="py-2 px-4 text-center">
                        <div class="flex justify-center">
                          <button (click)="removeItem(i)"
                            class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-500/10 transition-all cursor-pointer opacity-40 group-hover:opacity-100"
                            title="ลบรายการ">
                            <span class="material-icons text-[18px]">delete_outline</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Summary Footer -->
              <div class="bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-800/80 border-t border-slate-200 dark:border-slate-700 p-4 hidden md:flex justify-end gap-8 sticky left-0 w-full z-10">
                <div class="flex flex-col items-end justify-center">
                  <span class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">รวมเป็นเงิน (Subtotal)</span>
                  <span class="font-bold text-slate-700 dark:text-slate-200 text-base">{{ subTotal | number:'1.2-2' }}</span>
                </div>
                <div class="flex flex-col items-end justify-center">
                  <span class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">VAT {{ vatSetting.rateLabel() }}%</span>
                  <span class="font-bold text-slate-700 dark:text-slate-200 text-base">{{ vatAmount | number:'1.2-2' }}</span>
                </div>
                <div class="flex flex-col items-end justify-center pl-8 border-l-2 border-slate-200 dark:border-slate-700/50">
                  <span class="text-[11px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-0.5">ยอดรวมทั้งสิ้น (Grand Total)</span>
                  <span class="font-black text-xl text-rose-600 dark:text-rose-400 leading-none">{{ total | number:'1.2-2' }}</span>
                </div>
              </div>
            </div>

            <!-- Mobile Summary Footer -->
            <div class="md:hidden mt-5 bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 rounded-xl p-4 shadow-sm">
              <div class="flex justify-between items-center mb-2">
                <span class="text-[13px] font-medium text-slate-500 dark:text-slate-400">รวมเป็นเงิน (Subtotal)</span>
                <span class="font-bold text-slate-700 dark:text-slate-200 text-sm">{{ subTotal | number:'1.2-2' }}</span>
              </div>
              <div class="flex justify-between items-center mb-3">
                <span class="text-[13px] font-medium text-slate-500 dark:text-slate-400">VAT {{ vatSetting.rateLabel() }}%</span>
                <span class="font-bold text-slate-700 dark:text-slate-200 text-sm">{{ vatAmount | number:'1.2-2' }}</span>
              </div>
              <div class="flex justify-between items-center pt-3 border-t border-slate-200 dark:border-slate-700">
                <span class="text-[13px] font-bold text-slate-600 dark:text-slate-300">ยอดรวมทั้งสิ้น</span>
                <span class="font-black text-lg text-rose-600 dark:text-rose-400">{{ total | number:'1.2-2' }}</span>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="mt-6 flex flex-col sm:flex-row justify-end gap-3 border-t border-slate-100 dark:border-slate-800 pt-5">
              <button type="button" (click)="onClose()"
                class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                ยกเลิก
              </button>
              <button type="button" (click)="submit()" [disabled]="selectedItems.length === 0 || isLoading"
                class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                <span class="material-icons text-[18px]">save</span>
                {{ isLoading ? 'กำลังบันทึก...' : 'บันทึกการลงทะเบียน' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Component -->
<app-modal-register-parking-form-add *ngIf="isAddModalOpen" [customerId]="selectedCustomerId"
  [vehicleTypeId]="selectedVehicleTypeId" [statusType]="mode" [siteId]="selectedLocationId"
  [clientId]="selectedClientId" (close)="isAddModalOpen = false" (save)="handleModalSave($event)">
</app-modal-register-parking-form-add>

<app-modal-fullltax-form *ngIf="isFulltaxModalOpen" [customerId]="selectedCustomerId || 0" (close)="closeFulltaxModal()"
  (save)="saveFulltaxModal($event)"></app-modal-fullltax-form>

<!-- Confirm Modal -->
<app-pss-confirm-modal *ngIf="isConfirmModalOpen" [title]="isEditMode ? 'ยืนยันการแก้ไขฉบับร่าง?' : 'ยืนยันการลงทะเบียน?'" message="บันทึก "
  [highlight]="confirmHighlight" [messageSuffix]="confirmMessageSuffix" confirmLabel="ยืนยัน" cancelLabel="ยกเลิก"
  variant="warning" icon="check_circle" (confirm)="confirmSave()" (cancel)="closeConfirmModal()">
</app-pss-confirm-modal>

<!-- Reusable Dropdown Template -->
<ng-template #selectField let-label="label" let-key="key" let-options="options" let-selected="selected" let-icon="icon"
  let-placeholder="placeholder" let-disabled="disabled">
  <div class="relative w-full">
    <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
      {{ label }} <span *ngIf="key !== 'invoices' && key !== 'taxs'" class="text-rose-500">*</span>
    </label>
    <div class="relative group" (click)="$event.stopPropagation();">
      <!-- Select Trigger Button -->
      <button type="button" (click)="!disabled && toggleDropdown(key, $event)" [disabled]="disabled"
        class="w-full flex items-center justify-between px-3 py-2 bg-white dark:bg-slate-800 border-2 rounded-xl text-left transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-amber-500/10 shadow-[0_2px_10px_-3px_rgba(0,0,0,0.05)] text-[13px] font-medium min-h-[40px]"
        [ngClass]="{
          'border-slate-200 dark:border-slate-700 hover:border-amber-400 dark:hover:border-amber-500': openDropdown !== key && !disabled,
          'border-amber-400 dark:border-amber-500 ring-4 ring-amber-500/10 shadow-sm': openDropdown === key,
          'bg-slate-50 border-slate-100 dark:border-slate-700/50 text-slate-400 cursor-not-allowed opacity-70': disabled,
          'text-slate-700 dark:text-slate-200': selected !== null && !disabled,
          'text-slate-400 dark:text-slate-500': selected === null && !disabled
        }">
        <div class="flex items-center gap-2 limit-text w-full">
          <div class="w-6 h-6 rounded-md flex items-center justify-center transition-colors shadow-sm flex-shrink-0"
            [ngClass]="selected !== null ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
            <span class="material-icons text-[14px]">{{ icon }}</span>
          </div>
          <span class="truncate block overflow-hidden text-ellipsis whitespace-nowrap"
            style="max-width: calc(100% - 24px);">{{ getOptionName(key, selected) || placeholder }}</span>
        </div>
        <span class="material-icons text-slate-400 transition-transform duration-300 text-[18px] ml-1 flex-shrink-0"
          [ngClass]="{'rotate-180 text-amber-500': openDropdown === key}">expand_more</span>
      </button>

      <!-- Dropdown Options Menu -->
      <div *ngIf="openDropdown === key && !disabled"
        class="absolute z-[100] w-full mt-1.5 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] py-1.5 max-h-56 overflow-y-auto transform opacity-100 scale-100 transition-all origin-top custom-scrollbar animate-fade-in-up">

        <button *ngIf="!options || options.length === 0" disabled
          class="w-full text-left px-3 py-2 text-[12px] text-slate-400 italic">
          ไม่มีข้อมูล
        </button>

        <button *ngFor="let option of options"
          (click)="selectOption(key, option.value); $event.stopPropagation();"
          class="w-full text-left px-3 py-2.5 text-[12px] transition-colors flex items-center justify-between group"
          [ngClass]="{
            'bg-amber-50/80 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold': selected === option.value,
            'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-800 dark:hover:text-slate-100 font-medium': selected !== option.value
          }">
          <span class="truncate pr-2 block overflow-hidden text-ellipsis">{{ option.label }}</span>
          <span *ngIf="selected === option.value"
            class="material-icons text-[16px] text-amber-500 animate-scale-up flex-shrink-0">check_circle</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
